import { Search} from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Chip, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import {InputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance,  DialogType,  FormActions, usuarioEntity } from "../../utils/constants";
import * as yup from "yup";




const schema = yup.object({
  usuario: yup.string().required(),
  razon_social: yup.string().required(),
  celular: yup.number().required(),
  email: yup.string().email().required(),
  pass: yup.string().optional(),
  perfil: yup.number().required(),
  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional(),
  centro_op_destinos: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional().notRequired().nullable(),
  activo: yup.bool().required(),
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

export const MaestrosProcesos = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [roles,setRoles] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);
  const [centrosOpDestino,setCentrosOpDestino] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }

    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      return value;
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/get-log-procesos",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      product.perfil = product.cod_perfil;
      product.activo = product.ind_estado !== 'ACTIVO'?false:true;
      
      product.productos_asociados =  product.productos_asociados.map(product_aso=>({label:product_aso.descripcion || product_aso.label,value:product_aso.cod || product_aso.value}));

    
      delete product.clave;
      setProductoSeleccionado(product || {});
      setProductosOptions([...product.productos_asociados]);
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
    
    }

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      const urlService = typeAction === FormActions.AGREGAR?'maestros/agregar-usuario-and-products':'maestros/editar-usuario-and-products/'+dataForm.cod;
 
        let payload =  {
          usuario:dataForm.usuario,
          razon_social:dataForm.razon_social,
          celular:dataForm.celular,
          clave:dataForm.pass,
          email:dataForm.email,
          perfil:dataForm.perfil,
          productos:dataForm.productos_asociados.map(prod=>prod.value),
          cod_proveedor:dataForm.proveedor_asociado?.value,
          activo:dataForm.activo,
          centro_op_asociado:dataForm.centro_op_asociado?.value,
          centro_op_destinos:dataForm.centro_op_destinos?.map(item=>item.value),
        };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

    const onSearchProveedor = async (evt,value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
            search_query: value_search
          });
          setProveedorOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }

    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }
    const searchCpAsociado = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }
    const searchCpDestino = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOpDestino(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"nombre_proceso",
        keyValue:"nombre_proceso",
        label:"Nombre del proceso",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_hora_inicio_run",
        keyValue:"fecha_hora_inicio_run",
        label:"Fecha de inicio",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_hora_fin_run",
        keyValue:"fecha_hora_fin_run",
        label:"Fecha fin",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_hora_fin_run",
        keyValue:"fecha_hora_fin_run",
        label:"Tiempo obtenido",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.info.fecha_hora_fin_run).diff(props.info.fecha_hora_inicio_run,"minutes")+" mins",
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"estado_proceso",
        keyValue:"estado_proceso",
        label:"Estado del proceso",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip sx={{color:"white"}} color={props.value === 'FINALIZADO'?'secondary':'error'} label={props.value} ></Chip>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
   
       
     
    ];
   

    return (<>
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar proceso"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
      
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info ={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}